import { cn } from '@ifixit/ui/lib/utils';
import { FaIcon } from '@ifixit/ui/components/icon';

export function PlaceholderImage({ className }: { className?: string }) {
   return (
      <div
         className={cn(
            'flex justify-center items-center bg-white border border-gray-300 rounded',
            className
         )}
      >
         <div className="flex self-center justify-center items-center size-9 bg-gray-200 rounded-full">
            <FaIcon name="image" style="regular" className="size-4" />
         </div>
      </div>
   );
}
